import React, { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { createGame } from './gameSlice'
import { useHistory } from 'react-router-dom'
import Button from '../../ui/button'

function NewGameForm() {
    const dispatch = useDispatch()
    const history = useHistory()
    const doCreateGame = useCallback(() => {
        dispatch(createGame(gameId => history.push(`/g/${gameId}`)))
    }, [dispatch, history])

    return (
        <div>
            <Button variant="outlined" onClick={doCreateGame}>
                New Game
            </Button>
        </div>
    )
}

export default NewGameForm